/* eslint-disable no-console */
// eslint-disable-next-line no-unused-vars
import React from 'react';
import ReactDOM from 'react-dom';
import sniff from 'utils/sniff';
const assign = require('object-assign');

function empty() {}
// 用于处理使用Popup弹窗时，安卓的物理返回键问题
// 只在APP+Android内生效
let avoidAdrBack = sniff.qunar && sniff.android;
// 弹窗是否展示
let popupShown = false;
// 弹窗展示时，点击了安卓物理键后的响应
let popupBackAction = empty;

if(avoidAdrBack) {
    hysdk.ready(() => {
        hysdk.navigator.onClick((tagname, callback) => {
            // callback 必须先于逻辑代码执行，否则可能会导致阻止默认行为失效
            if(!tagname || (tagname.tagname !== 'left')) {
                return;
            }
            callback({
                data: popupShown
            });
            popupBackAction && popupBackAction();
        });
    });
}

const Popup = {
    show: function(Comp, props = {}, store, onClose) {
        const dom = document.createElement('div');

        // 实际执行关闭操作, "物理关闭"
        const domClose = function(...args) {
            let scrollable = document.querySelector('.scrollable');
            if(scrollable) {
                scrollable.style.overflow = 'auto';
            }
            setTimeout(()=>{
                ReactDOM.unmountComponentAtNode(dom);
            });

            props.maskClose && dom.removeEventListener('click', onMaskClose, false);
            try {
                dom.parentNode.removeChild(dom);
                onClose && onClose(...args);
            }catch(err) {
                console.log(err);
            }
        };

        function onMaskClose(e) {
            if (e.target === e.currentTarget) {
                domClose();
            }
        }

        props.maskClose && dom.addEventListener('click', onMaskClose, false);

        // 需要阻止物理键时，关闭弹窗需要额外操作
        const adrClose = function(...args) {
            domClose(...args);
            popupShown = false;
            popupBackAction = empty;
            let scrollable = document.querySelector('.scrollable');
            if(scrollable) {
                scrollable.style.overflow = 'auto';
            }
        };

        let close = domClose;
        if(avoidAdrBack) {
            close = adrClose;
            popupBackAction = adrClose;
            popupShown = true;
        }

        assign(dom.style, {
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 1005,
            background: 'rgba(0, 0, 0, .6)'
        }, props.wrapperStyle);

        setTimeout(() => {
            document.body.appendChild(dom);
            ReactDOM.render(<Comp
                {...props}
                close={close}
            />, dom);
        }, 10);

        return close;
    }
};

export default Popup;
